import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
  input,
  output,
} from '@angular/core';

@Directive({
  selector: '[siaScrollBottomNotify]',
  standalone: true,
})
export class SiaScrollBottomNotifyDirective implements OnInit, OnDestroy {
  readonly threshold = input<number | string>(40); // Accepts pixels or percentage (e.g., '20%')
  readonly disableBottomScroll = input(false);
  readonly bottomReached = output<void>();
  private latestNotifiedHeight = 0;

  #onScroll = (): void => {
    this.onScrollInternal();
  };

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.elementRef.nativeElement.addEventListener('scroll', this.#onScroll, {
      passive: true,
    });
  }

  ngOnDestroy(): void {
    this.elementRef.nativeElement.removeEventListener('scroll', this.#onScroll);
  }

  private onScrollInternal(): void {
    if (this.disableBottomScroll()) {
      return;
    }
    const element = this.elementRef.nativeElement;
    const threshold = this.calculateThreshold(element);
    if (
      element.scrollTop + element.clientHeight >=
        element.scrollHeight - threshold &&
      this.latestNotifiedHeight != element.scrollHeight
    ) {
      this.latestNotifiedHeight = element.scrollHeight;
      this.bottomReached.emit();
    }
  }

  private calculateThreshold(element: HTMLElement): number {
    if (
      typeof this.threshold() === 'string' &&
      String(this.threshold()).endsWith('%')
    ) {
      const percentage = parseFloat(this.threshold() as string) / 100;
      return element.scrollHeight * percentage;
    }
    if (
      typeof this.threshold() === 'string' &&
      String(this.threshold()).endsWith('px')
    ) {
      var res = parseFloat(this.threshold() as string);
      return res;
    }
    return Number(this.threshold());
  }
}
